import React from 'react';
import { FaLinkedin, FaYoutube, FaDiscord } from 'react-icons/fa';
import { motion } from 'framer-motion';

const CommunitySection = () => {
  const communityLinks = [
    {
      name: "LinkedIn",
      icon: <FaLinkedin className="h-8 w-8" />,
      description: "Follow us for industry updates, insights, and announcements",
      link: "https://www.linkedin.com/company/syntheta/",
      buttonText: "Follow on LinkedIn",
      color: "text-blue-600"
    },
    {
      name: "YouTube",
      icon: <FaYoutube className="h-8 w-8" />,
      description: "Watch tutorials, demos, and learn about synthetic data",
      link: "https://www.youtube.com/@aiportal481",
      buttonText: "Subscribe on YouTube",
      color: "text-red-600"
    },
    {
      name: "Discord",
      icon: <FaDiscord className="h-8 w-8" />,
      description: "Join our community to discuss, share, and learn together",
      link: "https://discord.gg/b9yXWc6K",
      buttonText: "Join Discord",
      color: "text-indigo-600"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <div className="py-24 bg-gradient-to-br from-blue-50 via-indigo-50 to-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-80 h-80 bg-blue-100 rounded-full opacity-10 blur-3xl"></div>
        <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-indigo-100 rounded-full opacity-10 blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-blue-600 mb-4">
            Join Our Community
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Connect with us across platforms to stay updated, learn more and grow with us. We would love to know you!
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {communityLinks.map((platform, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                className="group relative"
              >
                <div className="flex flex-col items-center text-center">
                  <div className={`mb-6 transform group-hover:scale-110 transition-transform duration-300 ${platform.color}`}>
                    {platform.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {platform.name}
                  </h3>
                  <p className="text-gray-600 mb-6">
                    {platform.description}
                  </p>
                  <a
                    href={platform.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors duration-300"
                  >
                    <span>{platform.buttonText}</span>
                    <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CommunitySection; 